import { render } from "./meta5.vue?vue&type=template&id=34113129&scoped=true"
import script from "./meta5.vue?vue&type=script&lang=js"
export * from "./meta5.vue?vue&type=script&lang=js"

import "./meta5.vue?vue&type=style&index=0&id=34113129&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34113129"]])

export default __exports__